import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card, Container, Title, Info,
  Button, Image,
  ButtonContainer,
  LinkButton,
} from './styles';

import Integration from '../../assets/integration/integration.png';

interface Props {
  action: (value: boolean) => void
}

export default function VirtualRaceIntegrationCard({ action }: Props) {
  const navigate = useNavigate();

  return (
    <Card>
      <Image src={Integration} />
      <Container>
        <Title>Conecte seu relógio ou Strava</Title>
        <Info>Vincule sua corrida feita em seu relógio ou Strava, integrando ao nosso app.</Info>
        <ButtonContainer>
          <Button onClick={() => navigate('/profile/edit?field=integracoes')}>Fazer integração</Button>
          <LinkButton onClick={() => action(false)}>Agora não</LinkButton>
        </ButtonContainer>
      </Container>
    </Card>
  );
}
